/**
 * Main styling file for About Page
 *
 * @author Creator-Solutions -> Owen Burns
 */

import styled from "styled-components";

const AboutContentContainer = styled.div`
  width: 38vw;
  height: auto;
  display: flex;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const AboutInnerContainer = styled.div`
  width: 38vw;
  height: auto;
  margin-top: 10px;

  &:hover {
    background-color: #212529;
  }

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 98vw;
  }
`;

const AboutGridContainer = styled.div`
  width: 30vw;
  margin: auto;
  display: grid;
  grid-template-rows: 50px 50px;
  grid-template-columns: 15vw 15vw;
  gap: 20px;
  margin-bottom: 25px;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 95vw;
    display: flex;
    flex-direction: column;
  }
`;

const AboutItem = styled.div`
  width: 35vw;
  height: 5vh;
  display: flex;
  margin: 10px auto;
  flex-direction: row;

  img {
    align-self: center;
  }

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 95vw;
    justify-content: center;
  }
`;

const AboutCaption = styled.p`
  font-size: 16px;
  color: #fff;
  align-self: center;
  margin-left: 15px;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    margin-left: 10px;
  }
`;

const AboutMe = styled.p`
  width: 35vw;
  font-size: 16px;
  color: #fff;
  align-self: center;
  margin-bottom: 25px;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 85vw;
    text-align: center;
  }
`;

export {
  AboutInnerContainer,
  AboutGridContainer,
  AboutCaption,
  AboutContentContainer,
  AboutItem,
  AboutMe,
};
